export { ProofOfImpactIcon } from './ProofOfImpactIcon'
